import React      from 'react';

export type DrawerContextType = {
	closeDrawer?: () => void;
	footer?: React.ReactNode,
	setFooter?: (reactNode: React.ReactNode) => void;
} | undefined;

const DrawerContext = React.createContext<DrawerContextType>(undefined);

export default DrawerContext;